import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePageConfig } from '@/contexts/PageConfigContext';
import TournamentCreateWizard from '@/widgets/TournamentCreateWizard';
import styles from './TournamentCreatePage.module.scss';

const TournamentCreatePage: React.FC = () => {
  const { t } = useTranslation('tournament');
  const [searchParams] = useSearchParams();

  // `?leagueId=` arrives from the league page CTA (`/matches/:leagueId`).
  // A non-numeric value is ignored — the wizard then starts at step 1.
  const leagueIdParam = Number(searchParams.get('leagueId'));
  const initialLeagueId = Number.isInteger(leagueIdParam) && leagueIdParam > 0
    ? leagueIdParam
    : undefined;

  usePageConfig({
    title: t('createTournament'),
  });

  return (
    <div className={styles.formWrapper}>
      <TournamentCreateWizard initialLeagueId={initialLeagueId} />
    </div>
  );
};

export default TournamentCreatePage;
